//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 6,
  includeInactive: false,
  queryKey: ['blogs'],
  queryOptions: {},
};

const getAll = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const { data } = await axios.get(`/api/blogs?${queryString}`);

  return data;
};

export const useGetAll = (queryParams = {}) => {
  const { queryKey, queryOptions, includeInactive, page, limit } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    includeinactive: includeInactive,
    offset: page * limit,
  };

  return useQuery([...queryKey], () => getAll(queryStringParams), {
    select: ({ data: blogs, total }) => ({ blogs, total }),
    initialData: {
      blogs: [],
      total: 0,
    },
    ...queryOptions,
  });
};
